import { CustomTableHeader } from '../../../../../components/CustomTable';
import { renderStatusDot } from '../../../ProdutosDAF/Produtos/auxiliarProdutosDaf';

export const valoresOffcanvas: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorIdentificacao: '',
  separadorObservacoes: '',

  //Específicos
  status: 'Status',
  restricaoComponenteAf: 'Restrição Componente AF',
  nomeSetorDaf: 'Setor DAF',
  sigla: 'Sigla',
  dataCriacao: 'Data de Criação',
  dataExtincao: 'Data de Extinção',
};

export type SetoresTableRow = {
  id: string | number;
  status: boolean;
  componenteAf: string;
  nomeSetorDaf: string;
  sigla: string;
  dataCriacao: string;
  dataExtincao: string;
  [key: string]: any;
};

export const headersSetores: CustomTableHeader<SetoresTableRow>[] = [
  { text: '', width: 1, key: '', renderable: false },
  { text: 'ID', width: 2, key: 'id', fieldType: 'number', textAlign: 'center' },
  {
    text: 'Status',
    width: 2,
    key: 'status',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'checkbox',
    filterDefaultValue: 'true',
  },
  { text: 'Componente AF', width: 7, key: 'componenteAf' },
  { text: 'Setor', width: 20, key: 'nomeSetorDaf' },
  { text: 'Sigla', width: 7, key: 'sigla' },
  { text: 'Data Criação', width: 7, key: 'dataCriacao' },
  { text: 'Data Extinção', width: 7, key: 'dataExtincao' },
];

export const fieldObjectOrgInters = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
